import { Storage } from '@capacitor/storage';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';

const INDEX_KEY = 'cards_offline_index';
const cardKey = (id) => `cards_offline_card_${id}`;

export async function getOfflineIndex() {
	const { value } = await Storage.get({ key: INDEX_KEY });
	return value ? JSON.parse(value) : [];
}

export async function setOfflineIndex(ids) {
	await Storage.set({ key: INDEX_KEY, value: JSON.stringify(ids) });
}

export async function getOfflineCard(id) {
	const { value } = await Storage.get({ key: cardKey(id) });
	return value ? JSON.parse(value) : null;
}

export async function setOfflineCard(card) {
	await Storage.set({ key: cardKey(card.id), value: JSON.stringify(card) });
}

export async function removeOfflineCard(id) {
	await Storage.remove({ key: cardKey(id) });
}

export async function resolveCardImageUri(path) {
	if (!path) return null;
	try {
		const { uri } = await Filesystem.getUri({ path, directory: Directory.Data });
		return Capacitor.convertFileSrc(uri);
	} catch (e) {
		console.error('resolveCardImageUri failed', e);
		return null;
	}
}

export async function writeCardImage(cardId, side, base64DataUri) {
	if (!base64DataUri) return null;

	const match = base64DataUri.match(/^data:([^;]+);base64,(.+)$/);
	if (!match) return null;

	const mimeType = match[1];
	const base64Data = match[2];
	const ext = mimeType.split('/')[1] || 'jpg';
	const path = `cards/card_${cardId}_${side}.${ext}`;

	try {
		const result = await Filesystem.writeFile({
			path,
			data: base64Data,
			directory: Directory.Data,
			recursive: true,
		});
		return {
			path,
			uri: Capacitor.convertFileSrc(result.uri),
		};
	} catch (e) {
		console.error('writeCardImage failed', e);
		return null;
	}
}

export async function deleteCardImages(cardId) {
	const extensions = ['jpg', 'jpeg', 'png', 'webp', 'gif'];
	const sides = ['front', 'back'];

	for (const side of sides) {
		for (const ext of extensions) {
			try {
				await Filesystem.deleteFile({
					path: `cards/card_${cardId}_${side}.${ext}`,
					directory: Directory.Data,
				});
			} catch {
				// file may not exist — skip
			}
		}
	}
}

export async function deleteAllCardImages() {
	try {
		await Filesystem.rmdir({
			path: 'cards',
			directory: Directory.Data,
			recursive: true,
		});
	} catch {
		// directory may not exist — skip
	}
}

export async function clearAllOfflineCards() {
	const ids = await getOfflineIndex();
	for (const id of ids) {
		await removeOfflineCard(id);
		await deleteCardImages(id);
	}
	await Storage.remove({ key: INDEX_KEY });
}
